import React, { useMemo } from "react";
import Table, { ColumnProps } from "components/basic/table";
import { TeamData } from "..";

export interface TeamTableProps {
  data: TeamData[];
}

const TeamTable = ({ data }: TeamTableProps) => {
  const columns: ColumnProps<TeamData>[] = useMemo(
    () => [
      {
        header: "Name",
        align: "left",
        cell: (row: TeamData) => row.name,
      },
      {
        header: "E-mail Address",
        align: "left",
        cell: (row: TeamData) => row.email,
      },
      {
        header: "Date Created",
        align: "left",
        cell: (row: TeamData) => new Date(row.joinedAt).toLocaleDateString(),
      },
      {
        header: "Access",
        align: "left",
        cell: (row: TeamData) => row.access,
      },
    ],
    [],
  );

  return <Table columns={columns} data={data} />;
};

export default TeamTable;
